import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';

export function LoginPage(): JSX.Element {
  const auth = useAuth();

  const navigate = useNavigate();

  useEffect(() => {
    if (!auth.isLoading) {
      if (!auth.isAuthenticated) {
        auth.signinRedirect();
      } else {
        navigate('/', { replace: true });
      }
    }
  }, [auth, navigate]);

  return <></>;
}
